import getDefaultCaptchaParams from './getDefaultRenderParams';
import reinitCaptchaIfSafari from '@/yandex-captcha/reinitCaptchaIfSafari';

/**
 * @module yandex-captcha/renderCaptchaWidget
 * @description
 * Рендер рекапчи
 * @param {object} options - параметры для рендера капчи
 * @param {object} options.renderParams - параметры рендера
 * @param {DOMElement} options.container - блок для рендера рекапчи
 * @param {object} options.context - контекст
 * @param {string} options.formType - тип формы. Возможные значения: "feedback", "comment", "review".
 *
 * @returns {void}
 */
export default ({ container, context, renderParams, formType }) => {
  const resolvedRenderParams = renderParams || getDefaultCaptchaParams(container);

  const captchaVerify = function(response) {
    const smartCaptchaTokenInput = container.querySelector('[name="yandex-smart-token"]');

    if (smartCaptchaTokenInput) {
      smartCaptchaTokenInput.value = response;
    } else {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'yandex-smart-token';
      input.value = response;
      container.appendChild(input);
    }

    // Клонируем элемент с formType если он передан
    if (formType) {
      const formTypeTokenInput = container.querySelector(`[name="${formType}[yandex-smart-token]"]`);

      if (formTypeTokenInput) {
        formTypeTokenInput.value = response;
      } else {
        const formTypeInput = document.createElement('input');
        formTypeInput.type = 'hidden';
        formTypeInput.name = `${formType}[yandex-smart-token]`;
        formTypeInput.value = response;
        container.appendChild(formTypeInput);
      }
    }

    window.EventBus.publish('yandex-captcha:insales:response', {
      container,
      response,
      formType
    });

    // Вызываем динамически установленный callback если он есть
    if (container._yandexCaptchaExecuteCallback) {
      container._yandexCaptchaExecuteCallback(response);
      // Очищаем callback после использования
      container._yandexCaptchaExecuteCallback = null;
    }
  };

  // Ренедерим неизменяемый виджет капчи, чтобы всегда отображался блок с уведомлением об обработке данных, этот виджет не будет выполняться, сбрасываться и т.д.
  if (!window.insalesYandexCaptchaRootShieldWidgetId && resolvedRenderParams.invisible) {
    const root = document.createElement('div');
    root.id = 'smartcaptcha-shield-root';
    root.setAttribute('aria-hidden', 'true');
    document.body.appendChild(root);

    window.insalesYandexCaptchaRootShieldWidgetId = window.smartCaptcha.render(root, {
      sitekey: resolvedRenderParams.sitekey,
      invisible: true,
      hideShield: false,
      shieldPosition: 'bottom-right',
      hl: resolvedRenderParams.hl,
      callback: () => {}
    });
  }

  let yandexCaptchaWidgetId = window.smartCaptcha.render(container, {
    callback: resolvedRenderParams.callback || captchaVerify,
    ...resolvedRenderParams
  });

  window.smartCaptcha.subscribe(yandexCaptchaWidgetId, 'token-expired', () => {
    if (!yandexCaptchaWidgetId) { return; }

    window.smartCaptcha.reset(yandexCaptchaWidgetId);

    if (!container) { return; }

    container.querySelectorAll(
      `[name="yandex-smart-token"], [name="${formType}[yandex-smart-token]"]`
    ).forEach((input) => {
      input.value = '';
    });
  });

  window.smartCaptcha.subscribe(yandexCaptchaWidgetId, 'success', () => {
    if (!container) { return; }

    reinitCaptchaIfSafari({
      context,
      captchaBlock: container,
      formType
    });

    const activeElement = document.activeElement;
    if (activeElement && activeElement.tagName === 'IFRAME') {
      // яндекс капча настолько кривая что после её ввода и отправки не закрывается клавиатура на мобильных устройствах
      activeElement.blur();
    }
  });

  container.dataset.yandexCaptchaWidgetId = yandexCaptchaWidgetId;

  if (context && context.settings) {
    context.settings.yandexCaptchaWidgets.push(yandexCaptchaWidgetId);
    window.yandexCaptchaWidget = yandexCaptchaWidgetId;
  }

  return;
};
